import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col min-h-0 overflow-hidden h-full" };
const _hoisted_2 = { class: "flex-shrink-0" };
const _hoisted_3 = {
    key: 0,
    class: "flex justify-center justify-around border-b border-gray-200 py-3"
};
const _hoisted_4 = {
    class: "flex flex-row px-6 py-2 border-b overflow-x-auto border-gray-200",
    "aria-label": "Breadcrumb"
};
const _hoisted_5 = {
    role: "list",
    class: "flex items-center space-x-4"
};
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "sr-only" }, "Home", -1);
const _hoisted_7 = { class: "flex items-center" };
const _hoisted_8 = ["onClick", "aria-current"];
const _hoisted_9 = { class: "flex flex-col overflow-auto h-full select-none" };
const _hoisted_10 = { class: "text-center p-2" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = { key: 1 };
const _hoisted_13 = {
    role: "list",
    class: "z-0 divide-y divide-gray-200 border-b border-gray-200"
};
const _hoisted_14 = ["onClick", "onDblclick", "onTouchend"];
const _hoisted_15 = { class: "flex flex-col" };
const _hoisted_16 = { class: "flex items-center mb-1" };
const _hoisted_17 = ["src"];
const _hoisted_18 = { class: "text-sm font-medium text-blue-700" };
const _hoisted_19 = {
    key: 0,
    class: "text-sm text-gray-500 truncate font-normal"
};
const _hoisted_20 = {
    key: 1,
    class: "text-sm text-gray-500 truncate font-normal"
};
export function render(_ctx, _cache) {
    const _component_Button = _resolveComponent("Button");
    const _component_home_icon = _resolveComponent("home-icon");
    const _component_chevron_right_icon = _resolveComponent("chevron-right-icon");
    const _component_folder_icon = _resolveComponent("folder-icon");
    const _component_trash_icon = _resolveComponent("trash-icon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.passwords, operation: _ctx.AccessOperations.create }) || _ctx.personal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_Button, {
                        class: "justify-center w-1/2 mx-1",
                        colored: "",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('show-add-password')))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('passwordManager.buttons.addPassword')), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_Button, {
                        class: "justify-center w-1/2 mx-1",
                        colored: "",
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('show-add-category')))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('passwordManager.buttons.addCategory')), 1)
                        ]),
                        _: 1
                    })
                ]))
                : _createCommentVNode("", true),
            _createElementVNode("nav", _hoisted_4, [
                _createElementVNode("ol", _hoisted_5, [
                    _createElementVNode("li", null, [
                        _createElementVNode("div", null, [
                            _createElementVNode("span", {
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.openCategory()), ["stop"])),
                                class: "cursor-pointer text-gray-400 hover:text-gray-500"
                            }, [
                                _createVNode(_component_home_icon, {
                                    class: "flex-shrink-0 h-5 w-5",
                                    "aria-hidden": "true"
                                }),
                                _hoisted_6
                            ])
                        ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadCrumbItems, (breadCrumbCategory) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: breadCrumbCategory.id
                        }, [
                            _createElementVNode("div", _hoisted_7, [
                                _createVNode(_component_chevron_right_icon, {
                                    class: "flex-shrink-0 h-5 w-5 text-gray-400",
                                    "aria-hidden": "true"
                                }),
                                _createElementVNode("span", {
                                    onClick: ($event) => (_ctx.openCategory(breadCrumbCategory)),
                                    class: _normalizeClass([{ 'cursor-pointer hover:text-gray-700': _ctx.selectedCategory && breadCrumbCategory.id !== _ctx.selectedCategory.id }, "ml-4 text-sm font-medium text-gray-500"]),
                                    "aria-current": breadCrumbCategory.name
                                }, _toDisplayString(breadCrumbCategory.name), 11, _hoisted_8)
                            ])
                        ]));
                    }), 128))
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("div", _hoisted_10, [
                (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.passwords, operation: _ctx.AccessOperations.create }) || _ctx.personal)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('passwordManager.list.emptyItemMessageAdmin')), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('passwordManager.list.emptyItemMessageUser')), 1))
            ], 512), [
                [_vShow, _ctx.sortedItems.length <= 0]
            ]),
            _createElementVNode("ul", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedItems, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: "bg-white"
                    }, [
                        _createElementVNode("a", {
                            class: _normalizeClass(["relative px-6 py-2 flex items-center justify-between cursor-pointer hover:bg-gray-50", { 'bg-gray-100': _ctx.selectedItem && _ctx.selectedItem.id === item.id }]),
                            onClick: ($event) => (_ctx.changeSelectedItem(item)),
                            onDblclick: ($event) => (_ctx.openCategory(item)),
                            onTouchend: ($event) => (_ctx.openCategory(item))
                        }, [
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                    (!!item.isFolder)
                                        ? (_openBlock(), _createBlock(_component_folder_icon, {
                                            key: 0,
                                            class: "h-5 w-5 mr-2"
                                        }))
                                        : _createCommentVNode("", true),
                                    (!item.isFolder)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            width: "20",
                                            height: "20",
                                            class: "scale-150 rounded-full mr-2",
                                            src: _ctx.getFavIconOfSite(index),
                                            alt: ""
                                        }, null, 8, _hoisted_17))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("p", _hoisted_18, _toDisplayString(item.name), 1),
                                    (!!item.isFolder && (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.passwords, operation: _ctx.AccessOperations.delete }) || _ctx.personal))
                                        ? (_openBlock(), _createBlock(_component_trash_icon, {
                                            key: 2,
                                            class: "w-4 h-4 ml-2 text-red-500",
                                            onClick: _withModifiers(($event) => (_ctx.$emit('show-remove-item', item)), ["stop"])
                                        }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true)
                                ]),
                                (!item.isFolder)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(item.nameIdentifier), 1))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$tc('passwordManager.items', parseInt(item.amount.toString()))), 1))
                            ]),
                            _createVNode(_component_chevron_right_icon, {
                                class: "w-5 h-5 text-gray-500",
                                onClick: ($event) => (_ctx.openCategory(item))
                            }, null, 8, ["onClick"])
                        ], 42, _hoisted_14)
                    ]));
                }), 128))
            ])
        ])
    ]));
}
